var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M90.1573 177.75C139.139 177.75 178.846 138.043 178.846 89.0616C178.846 40.0803 139.139 0.373047 90.1573 0.373047C41.176 0.373047 1.46875 40.0803 1.46875 89.0616C1.46875 138.043 41.176 177.75 90.1573 177.75Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.997 48.355C101.997 48.355 104.568 60.7493 103.45 69.325C103.341 70.1563 103.068 70.9577 102.648 71.6831C102.228 72.4085 101.668 73.0435 101.001 73.5515C100.334 74.0594 99.573 74.4304 98.7619 74.6428C97.9509 74.8553 97.1059 74.9051 96.2756 74.7893C91.9684 74.1722 86.3113 72.0636 84.1256 65.5965L79.0598 55.0536C79.0598 55.0536 76.1284 48.3422 82.6084 42.4022C89.0884 36.4622 100.801 40.7179 101.997 48.355Z",
    fill: "#F4A28C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9817 56.9707L78.3359 98.435L101.247 97.7021L93.2374 67.8221L79.9817 56.9707Z",
    fill: "#F4A28C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9968 49.2419C95.1284 49.8521 91.2027 50.016 87.2968 49.7305C88.6218 51.3039 89.457 53.2309 89.6992 55.2736C89.9414 57.3163 89.58 59.3852 88.6597 61.2248C87.8053 63.0272 86.3494 64.4755 84.5425 65.3203C82.7355 66.1651 80.6906 66.3536 78.7597 65.8534L77.0497 49.6791C76.722 47.3721 77.0273 45.0194 77.9332 42.8726C78.839 40.7258 80.3113 38.8654 82.1925 37.4905C83.8145 36.2955 85.5108 35.2047 87.2711 34.2248C91.7068 31.8077 98.8425 34.0962 102.7 30.4705C103.082 30.1071 103.553 29.8493 104.065 29.7224C104.577 29.5954 105.113 29.6036 105.621 29.7461C106.129 29.8887 106.592 30.1607 106.963 30.5356C107.334 30.9105 107.602 31.3754 107.74 31.8848C109.025 36.7062 109.09 44.5491 102.764 48.0205C101.585 48.6342 100.312 49.047 98.9968 49.2419Z",
    fill: "#24285B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9088 60.6978C89.9088 60.6978 89.2402 55.8635 85.6402 56.6735C82.0402 57.4835 82.9788 64.465 87.993 64.5292L89.9088 60.6978Z",
    fill: "#F4A28C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.22 56.25L107.296 60.6729C107.525 60.9248 107.688 61.2303 107.768 61.5614C107.849 61.8925 107.845 62.2386 107.756 62.5677C107.668 62.8967 107.498 63.1983 107.263 63.4446C107.027 63.6909 106.734 63.8741 106.409 63.9771L101.703 65.4557L103.22 56.25Z",
    fill: "#F4A28C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M95.2725 74.2893C92.3718 73.9096 89.6455 72.6895 87.4297 70.7793C87.4297 70.7793 88.7154 78.275 97.8054 84.7293L95.2725 74.2893Z",
    fill: "#CE8172"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4088 154.607C30.4088 154.607 29.046 98.9355 89.0888 96.0555C149.132 93.1755 147.55 157.063 147.55 157.063C147.55 157.063 90.9017 208.697 30.4088 154.607Z",
    fill: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlank);
export default __webpack_public_path__ + "static/media/user_blank.b87c99984f8d138de44886397fb49f85.svg";
export { ForwardRef as ReactComponent };